import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CashRegisterService } from '@bcmServices/cash-registers/cash-register.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BcmCashRegister } from '@shared/models/bcm-cash-register';
import { TolgeeService } from '@core/translation/tolgee.service';
import { TsePaymentContext } from '@modules/bcm/accounting/invoices/dialogs/tse-payment-flow.util';

@UntilDestroy()
@Component({
    selector: 'app-check-pay-by-cash',
    templateUrl: './check-pay-by-cash.component.html',
    styleUrls: ['./check-pay-by-cash.component.scss'],
    standalone: false
})
export class CheckPayByCashComponent implements OnInit {

    @Input() checkCancel: boolean;
    @Input() parentFormGroup: UntypedFormGroup;

    /** Add-on des Mandanten und angemeldete Kasse getrennt – siehe TsePaymentContext (#6950). */
    @Output() tseContextEmitter: EventEmitter<TsePaymentContext> = new EventEmitter<TsePaymentContext>();

    checkAddonDone = false;
    addonStatus = false;

    checkCashRegisterDone = false;
    cashRegister: BcmCashRegister;

    constructor(private _cashRegisterService: CashRegisterService,
                private _changeRef: ChangeDetectorRef,
                private _tolgee: TolgeeService) {
    }

    ngOnInit(): void {
        this.checkTseConditions();
    }

    checkTseConditions(): void {
        this._cashRegisterService.getTsePaymentContext()
            .pipe(untilDestroyed(this))
            .subscribe(context => {
                this.checkAddonDone = true;
                this.addonStatus = context.hasTseAvailable;
                this.tseContextEmitter.next(context);

                if (!context.hasTseAvailable) {
                    this._reject('dialogs.payByCash.requiresDockSiteAddon');
                    this._changeRef.markForCheck();
                    return;
                }

                this.checkCashRegisterDone = true;
                this.cashRegister = context.cashRegister;

                if (!this.cashRegister?.id) {
                    this._reject('dialogs.payByCash.notLoggedInAtRegister');
                } else if (this.checkCancel && !this.cashRegister.currentUser?.canCancel) {
                    this._reject('dialogs.payByCash.noCancelPermission');
                } else {
                    this.parentFormGroup.get('checkPayByCash').setValue(true);
                }

                this._changeRef.markForCheck();
            });
    }

    private _reject(translationKey: string): void {
        this.parentFormGroup.get('checkPayByCash').setErrors([this._tolgee.translate(translationKey)]);
        this.parentFormGroup.get('checkPayByCash').setValue(false);
    }
}
